import {useEffect, useState} from "react";
import AppView, {AppContainerProps, AppProps as _AppProps} from "./App-view";
import {getAppBase} from "../../util/env";
export interface AppProps extends Omit<_AppProps, keyof AppContainerProps> {
  localeInPath: string,
}
function App(props: AppProps) {
  const {
    localeInPath,
  } = props;
  const [headerHeight, setHeaderHeight] = useState<number | undefined>();
  const [reactAppBasePath, setReactAppBasePath] = useState((localeInPath ? "/" + localeInPath : "") + getAppBase());
  useEffect(() => {
    setReactAppBasePath(
        (localeInPath ? "/" + localeInPath : "") +
        getAppBase()
    );
  }, [localeInPath]);
  return <AppView reactAppBasePath={reactAppBasePath} headerHeight={headerHeight} setHeaderHeight={setHeaderHeight}{...props} />
}
export default App;
